import React, {useState, useRef, useEffect} from 'react';
import styles from "./SDialogHeader.module.css";
import FontIcon from "../FontIcon/fontIcon";

interface RedeemHeaderProps {
    title: string;
    icon?: any;
    onClickBack: () => void;
}

const SDialogHeader: React.FC<RedeemHeaderProps> = (props) => {
    const {title,icon,onClickBack} = props;

    return (
        <>
            <div className={`${styles.header_box}`} >
                <div className={styles.header}>
                    {/*//返回按钮*/}
                    <div
                        className={`btn ${styles.headBtn}`}
                        onClick={onClickBack}
                    >
                        <FontIcon
                            icon={'s-back'}
                            style={{
                                color: '#fff',
                                verticalAlign: '-0.1rem'
                            }}
                        />
                    </div>

                    {/*标题内容*/}
                    <div className={`center`}>
                        {icon && (
                            <div className={`${styles.icon} center`}>
                                <FontIcon
                                    icon={'s-back'}
                                    style={{
                                        color: '#ffffff',
                                        marginRight: '0.2rem',
                                    }}
                                />
                            </div>
                        )}
                        <div className={styles.title}>
                            <span>{title ? title:'Title'}</span>
                        </div>
                    </div>

                    <div className={`btn ${styles.headBtn}`}></div>
                </div>
            </div>
        </>
    );
};

export default SDialogHeader;
